import(/* webpackMode: "eager" */ "/app/apps/explore/app/(explore)/@sidebar/layout.tsx");
